var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#07c160;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WeChat"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "WeChat-2",
    "data-name": "WeChat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WeChat-3",
    "data-name": "WeChat",
    className: "cls-2",
    d: "M1252.8,673.73a5,5,0,1,1,5-5.05,5,5,0,0,1-5,5.05m-25.22,0a5,5,0,1,1,5-5.05,5,5,0,0,1-5,5.05M1265,702.6c8-5.78,13.07-14.33,13.07-23.83,0-17.41-16.94-31.52-37.83-31.52s-37.83,14.11-37.83,31.52,16.94,31.53,37.83,31.53a44.83,44.83,0,0,0,12.35-1.73,3.68,3.68,0,0,1,1.11-.17,4,4,0,0,1,2,.58l8.28,4.78a1.35,1.35,0,0,0,.73.24,1.25,1.25,0,0,0,1.26-1.26,3.6,3.6,0,0,0-.2-.92c0-.18-1.07-4-1.71-6.36a3.19,3.19,0,0,1-.13-.81,2.53,2.53,0,0,1,1.06-2",
    transform: "translate(-1108 -554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WeChat-4",
    "data-name": "WeChat",
    className: "cls-2",
    d: "M1213,644.22a6,6,0,1,1,6-6.05,6.05,6.05,0,0,1-6,6.05m-30.26,0a6,6,0,1,1,6-6.05,6.05,6.05,0,0,1-6,6.05m15.13-31.78c-25.07,0-45.4,16.94-45.4,37.83,0,11.4,6.12,21.66,15.69,28.6a3,3,0,0,1,1.27,2.46,3.52,3.52,0,0,1-.16,1c-.76,2.85-2,7.41-2,7.63a4.27,4.27,0,0,0-.25,1.1,1.52,1.52,0,0,0,1.52,1.52,1.74,1.74,0,0,0,.87-.29l9.94-5.73a4.76,4.76,0,0,1,2.41-.7,4.51,4.51,0,0,1,1.33.2,53.87,53.87,0,0,0,14.82,2.07q1.26,0,2.49-.06a29.29,29.29,0,0,1-1.52-9.27c0-19,18.53-34.5,41.4-34.5.83,0,1.65,0,2.47.07-3.42-18.07-22.19-31.9-44.84-31.9",
    transform: "translate(-1108 -554)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChat);
export default __webpack_public_path__ + "static/media/WeChat.df96ce67e0b02151b8f9187c7bd8a367.svg";
export { ForwardRef as ReactComponent };